"use client";
import * as stylex from "@stylexjs/stylex";
import { Alert, Button, Inline, Stack, Text } from "@softmax/design-system";
import { breakpoints, spacing } from "@softmax/design-system/tokens.stylex";

import { IdentityField, type LeagueIdentityField } from "./identity-field";

const styles = stylex.create({
  fields: {
    display: "grid",
    gridTemplateColumns: {
      default: "repeat(2,minmax(0,1fr))",
      [breakpoints.compact]: "minmax(0,1fr)",
    },
    alignItems: "start",
    gap: spacing.space16,
  },
});

export function LeagueIdentity({
  name,
  address,
  defaultLeague,
}: Readonly<{
  name?: LeagueIdentityField | undefined;
  address?: Readonly<{ field: LeagueIdentityField; root: string }> | undefined;
  defaultLeague?:
    | Readonly<{
        current: boolean;
        pending: boolean;
        error?: string | undefined;
        onMakeDefault(): void;
      }>
    | undefined;
}>) {
  return (
    <Stack width="auto">
      {address && <Text>Coworld: {address.root}</Text>}
      <div {...stylex.props(styles.fields)}>
        {name && (
          <IdentityField
            label="League name"
            action="Save league name"
            field={name}
          />
        )}
        {address && (
          <IdentityField
            label="League address segment"
            action="Save address"
            field={address.field}
            description="Up to 32 lowercase letters, numbers or hyphens; start with a letter or number. Leave blank to use the league name."
          />
        )}
      </div>
      {defaultLeague && (
        <Stack width="auto" gap={8}>
          <Text>
            {defaultLeague.current
              ? "This is the Coworld’s default league."
              : "Make this the default league for the Coworld’s root address."}
          </Text>
          {!defaultLeague.current && (
            <Inline>
              <Button
                disabled={defaultLeague.pending}
                onClick={defaultLeague.onMakeDefault}
              >
                {defaultLeague.pending
                  ? "Changing default…"
                  : "Make default league"}
              </Button>
            </Inline>
          )}
          {defaultLeague.error && (
            <Alert tone="danger">{defaultLeague.error}</Alert>
          )}
        </Stack>
      )}
    </Stack>
  );
}
